import start from '../../../../common/microservices/loaders/order-calculator/lazy'

import '../lazy-microservices/lazy-microservices'

start(() => import('./render'), 'microservice__new-order__root', {
  lazyStoreManagerLoader: () => import('../../../../common/microservices/lazy-store-manager'),
})
